module.exports = __webpack_public_path__ + "img/company.8b2c78d9.svg";